/**
 * @fileoverview useVtcHotkeys Hook
 * 
 * Custom hook that manages keyboard shortcuts for the Virtual Test Center.
 * Handles magnification toggle and other VTC-specific shortcuts.
 * 
 * @module hooks/useVtcHotkeys
 */

import { useHotkeys } from 'react-hotkeys-hook';

/**
 * useVtcHotkeys Hook
 * 
 * Registers all keyboard shortcuts for VTC including:
 * - Magnification toggle (Cmd+M / Ctrl+M)
 * 
 * @param {Object} params - Hook parameters
 * @param {Function} params.toggleMagnification - Function to toggle magnification feature
 */
export function useVtcHotkeys({ toggleMagnification }) {
  // ============================================================================
  // MAGNIFICATION CONTROL
  // ============================================================================

  // Cmd+M (Mac) / Ctrl+M (Windows/Linux): Toggle magnification
  useHotkeys(
    'mod+m',
    (event) => {
      event.preventDefault();
      toggleMagnification();
    },
    { enableOnContentEditable: true }
  );
}
